export default __webpack_public_path__ + "static/media/unchecked.4b47d58c.svg";